import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { User, Bookmark, Clock, CreditCard, FileText, Bell, LogOut, ChevronRight, Settings, Menu, X } from 'lucide-react';
const Sidebar: React.FC = () => {
  const location = useLocation();
  const {
    logout
  } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const menuItems = [{
    name: 'My Dashboard',
    path: '/dashboard',
    icon: <User size={20} data-id="element-284" />
  }, {
    name: 'My Bookings',
    path: '/dashboard/bookings',
    icon: <Bookmark size={20} data-id="element-285" />
  }, {
    name: 'Order History',
    path: '/dashboard/orders',
    icon: <Clock size={20} data-id="element-286" />
  }, {
    name: 'Payment Methods',
    path: '/dashboard/payments',
    icon: <CreditCard size={20} data-id="element-287" />
  }, {
    name: 'Travel Documents',
    path: '/dashboard/documents',
    icon: <FileText size={20} data-id="element-288" />
  }, {
    name: 'Notifications',
    path: '/dashboard/notifications',
    icon: <Bell size={20} data-id="element-289" />
  }, {
    name: 'Profile Settings',
    path: '/dashboard/settings',
    icon: <Settings size={20} data-id="element-290" />
  }];
  const handleLogout = () => {
    logout();
    // Redirect to home page after logout
    window.location.href = '/';
  };
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return <>
      {/* Mobile Menu Button */}
      <div className="lg:hidden fixed top-4 left-4 z-30" data-id="element-291">
        <button onClick={toggleMobileMenu} className="p-2 bg-navy-900 text-white rounded-md" data-id="element-292">
          {isMobileMenuOpen ? <X size={24} data-id="element-293" /> : <Menu size={24} data-id="element-294" />}
        </button>
      </div>
      {/* Sidebar for Desktop */}
      <aside className="hidden lg:flex flex-col w-64 bg-white border-r border-gray-200 h-full" data-id="element-295">
        <div className="p-6 border-b border-gray-200" data-id="element-296">
          <Link to="/" className="flex items-center" data-id="element-297">
            <span className="text-navy-900 font-bold text-xl" data-id="element-298">
              Kembara Ustaz
            </span>
            <span className="text-gold-500 ml-1" data-id="element-299">✈</span>
          </Link>
        </div>
        <nav className="flex-grow py-6 px-4" data-id="element-300">
          <ul className="space-y-1" data-id="element-301">
            {menuItems.map(item => <li key={item.path} data-id="element-302">
                <Link to={item.path} className={`flex items-center px-4 py-3 rounded-md transition-colors ${isActive(item.path) ? 'bg-navy-900 text-white' : 'text-navy-700 hover:bg-navy-50'}`} data-id="element-303">
                  <span className="mr-3" data-id="element-304">{item.icon}</span>
                  <span data-id="element-305">{item.name}</span>
                  {isActive(item.path) && <ChevronRight size={18} className="ml-auto" data-id="element-306" />}
                </Link>
              </li>)}
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-200" data-id="element-307">
          <button onClick={handleLogout} className="flex items-center w-full px-4 py-3 text-red-600 hover:bg-red-50 rounded-md transition-colors" data-id="element-308">
            <LogOut size={20} className="mr-3" data-id="element-309" />
            <span data-id="element-310">Logout</span>
          </button>
        </div>
      </aside>
      {/* Mobile Sidebar */}
      {isMobileMenuOpen && <div className="lg:hidden fixed inset-0 z-20" data-id="element-311">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={toggleMobileMenu} data-id="element-312"></div>
          <div className="fixed top-0 left-0 bottom-0 w-64 bg-white shadow-lg z-30" data-id="element-313">
            <div className="p-6 border-b border-gray-200" data-id="element-314">
              <Link to="/" className="flex items-center" data-id="element-315">
                <span className="text-navy-900 font-bold text-xl" data-id="element-316">
                  Kembara Ustaz
                </span>
                <span className="text-gold-500 ml-1" data-id="element-317">✈</span>
              </Link>
            </div>
            <nav className="py-6 px-4" data-id="element-318">
              <ul className="space-y-1" data-id="element-319">
                {menuItems.map(item => <li key={item.path} data-id="element-320">
                    <Link to={item.path} onClick={toggleMobileMenu} className={`flex items-center px-4 py-3 rounded-md transition-colors ${isActive(item.path) ? 'bg-navy-900 text-white' : 'text-navy-700 hover:bg-navy-50'}`} data-id="element-321">
                      <span className="mr-3" data-id="element-322">{item.icon}</span>
                      <span data-id="element-323">{item.name}</span>
                      {isActive(item.path) && <ChevronRight size={18} className="ml-auto" data-id="element-324" />}
                    </Link>
                  </li>)}
              </ul>
            </nav>
            <div className="p-4 border-t border-gray-200" data-id="element-325">
              <button onClick={handleLogout} className="flex items-center w-full px-4 py-3 text-red-600 hover:bg-red-50 rounded-md transition-colors" data-id="element-326">
                <LogOut size={20} className="mr-3" data-id="element-327" />
                <span data-id="element-328">Logout</span>
              </button>
            </div>
          </div>
        </div>}
    </>;
};
export default Sidebar;